import { Button } from "@mui/material";
import { motion } from "framer-motion";
import styled from "styled-components";

export const Header = styled.header`
  display: flex;
  gap: 14px;
  flex-basis: 100%;
`;

export const SendReminderButton = styled(Button)`
  background: linear-gradient(90deg, #452d84 0%, #100a1e 100%) !important;
  padding: 10px 36px !important;
  border-radius: 6px !important;
  text-transform: none !important;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  font-family: "Inter" !important;
  font-size: 14px !important;
  margin-top: 21px !important;
  color: white !important;
`;

export const OverviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

export const CashDepositCardWrapper = styled.div`
  box-shadow: 0px 2px 6px 1px #4a4a4a1a;
  border-radius: 10px;
  padding: 24px 24px 36px 24px;
  background: white;
  position: relative;
  max-width: 380px;
  min-width: 320px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 200px;
  & *:not(img) {
    z-index: 10;
    position: relative;
  }
  & > footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: auto;
    padding-bottom: 10px;
  }
  & > header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  & > img {
    position: absolute;
    bottom: 0;
    left: 0;
    user-select: none;
    height: 100%;
    top: 0;
    z-index: 1;
  }
`;

export const InsurerLogo = styled.img`
  max-width: 54px;
  max-height: 34px;
  margin-left: 24px;
`;

export const CashDepositContainer = styled.div`
  margin-top: 28px;
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
`;

export const ProductDetailCardWrapper = styled(motion.section)`
  background: #f3eeff;
  padding: 36px;
  border-radius: 0px 10px 10px 10px;
  border-width: 0px 1px 1px 1px;
  border-style: solid;
  border-color: #d8d0f1;
  position: relative;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  @media (max-width: 768px) {
    padding: 24px;
  }
  & > :not(img) {
    z-index: 10;
    position: relative;
  }
  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const CoverageDetailsCard = styled.div`
  background: white;
  padding: 36px 24px;
  border-radius: 10px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`;

export const CoverageDetailsCardHeader = styled.header`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: ${({ isOnlyEmployees }) =>
    isOnlyEmployees ? "flex-start" : "center"};
  flex-direction: ${({ isOnlyEmployees }) =>
    isOnlyEmployees ? "column" : "row"};
`;

export const DependentsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 36px;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, and Opera */
  }
`;

export const Grid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(3, auto);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  @media (max-width: 1400px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const CustomGrid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(3, auto);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  /* @media (max-width: 1400px) {
    grid-template-columns: repeat(4, 1fr);
  } */
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const QuickLinksWrapper = styled.div`
  background: #452d84;
  border-radius: 10px;
  position: relative;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  & > header {
    padding: 21px 18px 14px 18px;
  }
  & > img {
    position: absolute;
    top: 0;
    right: 0;
  }
  & > ul {
    list-style-type: none;
    padding: 24px 18px;
  }
`;

export const LinkListItem = styled(Button)`
  color: white !important;
  text-transform: none !important;
  font-family: "Inter" !important;
  font-size: 14px !important;
  display: flex;
  text-decoration: underline !important;
  justify-content: space-between !important;
  text-align: left;
  width: 100%;
  .arrow-icon {
    transition: transform 0.3s ease;
  }
  &:hover .arrow-icon {
    transform: translateX(3px);
  }
`;

export const Dependent = styled.div`
  display: flex;
  gap: 8px;
  & > :first-child {
    background: #fdf2e1;
    border-radius: 100%;
    width: 34px;
    height: 34px;
    display: grid;
    place-items: center;
  }
`;

export const EnrolmentContent = styled.section`
  display: flex;
  gap: 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

export const ProductFooter = styled.footer`
  display: flex;
  justify-content: flex-end;
`;

export const ClaimsSummaryWrapper = styled.section`
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 36px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ReminderConfirmationModalWrapper = styled.section`
  background: white;
  width: clamp(300px, 50%, 800px);
  padding: 48px 86px 24px 86px;
  box-shadow: 1px 1px 6px 4px #5f5d5d1a !important;
  border-radius: 14px !important;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  & footer {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-top: 24px;
  }
`;

export const BaseButton = styled(Button)`
  background: ${(props) =>
    props.variant === "contained" ? "#452D84" : "transparent"} !important;
  border: ${(props) =>
    props.variant === "outlined" && "1px solid #E0E0E0"} !important;
  padding: 10px 46px !important;
  text-transform: none !important;
  font-family: "Inter" !important;
  font-size: 14px !important;
  border-radius: 8px !important;
  color: ${(props) =>
    props.variant === "contained" ? "white" : "#452d84"} !important;
`;

export const ProductTabWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  & > img {
    width: 20px;
    height: 20px;
  }
`;

export const TabsContainer = styled.div`
  width: 100%;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  & .MuiTabs-root {
    max-width: 1140px;
    @media (max-width: 1200px) {
      max-width: 950px;
    }
    @media (max-width: 768px) {
      max-width: 760px;
    }
    @media (max-width: 480px) {
      max-width: 570px;
    }
  }
  & .MuiTabs-scrollableX {
    overflow-x: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }
`;

export const BackgroundAbstraction = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  /* height: 100%; */
`;
